import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { useMemo } from 'react';
import { AttributeOption } from '@mark43/cad-api';

export const usePrimaryPoliceSubdivisionOptions = (): AttributeOption[] => {
    const allSubdivisions =
        useBootstrapState().subdivisionOptionsBootstrapResponse
            ?.combinedSubdivisionOptionsBootstrapView;

    return useMemo(() => {
        if (allSubdivisions) {
            return [
                ...allSubdivisions.policeSubdivision1Options,
                ...allSubdivisions.policeSubdivision2Options,
                ...allSubdivisions.policeSubdivision3Options,
                ...allSubdivisions.policeSubdivision4Options,
                ...allSubdivisions.policeSubdivision5Options,
            ]
                .map((subdivision) => ({ ...subdivision, isOther: false }))
                .filter((subdivision) => subdivision.isSubdivisionPrimary);
        }

        return [];
    }, [allSubdivisions]);
};
